import { Checkbox, CheckboxProps, FormControlLabel, FormControlLabelProps } from '@mui/material';
import React from 'react';
import { UseWatchProps, Controller, useFormContext } from 'react-hook-form';

interface ICheckboxLabelWithControllerProps extends Omit<FormControlLabelProps, 'control'> {
  name: string;
  hookFormProps?: Omit<UseWatchProps<any>, 'name' | 'render'>;
  checkboxProps?: Omit<CheckboxProps, 'checked' | 'onChange'>;
}

/**
 * FormControlLabel (Checkbox) с react-hook-form Controller
 *
 * @param name - для react-hook-form Controller
 * @param checkboxProps
 * @param hookFormProps
 * @param rest - наследуются от FormControlLabelProps
 */
export const CheckboxLabelWithController: React.FC<ICheckboxLabelWithControllerProps> = (props) => {
  const { name, checkboxProps, hookFormProps, ...rest } = props;

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={!!field.value}
              onChange={field.onChange}
              sx={(theme) => ({
                color: theme.palette.text.secondary,
              })}
              {...checkboxProps}
            />
          }
          {...rest}
        />
      )}
      {...hookFormProps}
      control={hookFormProps?.control || control}
    />
  );
};
